/* istanbul ignore file */
import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from 'src/app/api/base';
import { URL_APPLICATION_INVENTORY } from 'src/app/api/urls';

interface useGetAppleApplicationsArgs {
  deviceId: string;
  deviceFamily: string;
  enabled?: boolean;
  params: {
    page?: number;
    sizePerPage?: number;
    ordering?: string;
    search?: string;
    [k: string]: any;
  };
}

export function useGetAppleApplications(args: useGetAppleApplicationsArgs) {
  const { deviceId, deviceFamily, params, enabled = true } = args;

  return useQuery({
    queryKey: ['device-applications', deviceId, deviceFamily, params, enabled],
    queryFn: async () => {
      const url =
        deviceFamily === 'Mac'
          ? URL_APPLICATION_INVENTORY
          : `/mdm/${deviceId}/installed-apps/`;

      return (
        await api(url).get({
          computer_id: deviceId,
          ...params,
        })
      ).data;
    },
    placeholderData: keepPreviousData,
    enabled,
  });
}
